import {graphql} from 'gatsby'
import React from 'react'

import type {TableSliceFragment} from '@/graphql-types'
import type {TableProps} from '@/sections/table'
import {Table} from '@/sections/table'
import {Section} from '@/styles/grid'

export const TableSlice = ({primary, items}: TableSliceFragment) => {
    const tableData: TableProps['tableData'] = {
        columnHeadings: [
            primary.column_1_heading,
            primary.column_2_heading,
            primary.column_3_heading,
            primary.column_4_heading,
            primary.column_5_heading,
            primary.column_6_heading,
            primary.column_7_heading,
        ],
        rows: items.map((item) => ({
            heading: item.row_heading,
            cells: [
                item.column_1_content.richText,
                item.column_2_content.richText,
                item.column_3_content.richText,
                item.column_4_content.richText,
                item.column_5_content.richText,
                item.column_6_content.richText,
                item.column_7_content.richText,
            ],
        })),
    }

    return (
        <Section>
            <Table title={primary.title} tableData={tableData} />
        </Section>
    )
}

export const tableSliceFragment = graphql`
    fragment TableSlice on PrismicSlicePageDataBodyTable {
        __typename
        primary {
            title
            column_1_heading
            column_2_heading
            column_3_heading
            column_4_heading
            column_5_heading
            column_6_heading
            column_7_heading
        }
        items {
            row_heading
            column_1_content {
                richText
            }
            column_2_content {
                richText
            }
            column_3_content {
                richText
            }
            column_4_content {
                richText
            }
            column_5_content {
                richText
            }
            column_6_content {
                richText
            }
            column_7_content {
                richText
            }
        }
    }
`
